
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Alert from 'vux/src/components/alert/index.vue'


const dataList = [{
src:"",
state:"",
name:"",
money:""
}];
export default {
components: {
Swiper,
Divider,
Alert
},
data () {
return{
editSkuInfo:{listQuery: Object.assign({}, dataList)},
swiperIndex: 0,
isShow:false,
model:{demandId : this.$route.query.demandId},
list:{},
img:[],
show:false,
message:"",
}
},
created(){
window.location.href="/m/mall/demand/detail.html?demandId="+this.model.demandId;


















},
methods: {
goBack(){




window.history.go(-1);
},
swiperChange (index) {
this.swiperIndex = index
},
addHistory(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/app/addFoot',this.model,{emulateJSON:true}).then(function(res){

if(res.body.success)
{
}
},function(res){
console.log(res.status);
});
},
ShowColler(){
this.show=true
this.message="手机端暂不支持此功能。请移步至PC端操作"
}
}
}



// WEBPACK FOOTER //
// ./src/views/mall/demand/detail.vue